<template>
  <div class="ricercaElementoField">
    <div>
      <div class="van-cell van-cell--large" style="overflow: visible;">
        <i v-if="item.icon" :class="item.icon" class="van-icon van-icon-user-o van-cell__left-icon"></i>
        <div class="van-cell__title" @click="onClickCell">
          <span>{{ config.descrizione(item) }}</span>
          <!-- <div class="van-cell__label clienti-lr-label"></div> -->
        </div>
        <!-- <div class="van-cell__value clienti-lr-value">
          <span>12345678901</span>
        </div> -->

          <!-- Dropdown personalizzato -->
        <div v-if="hasGiacenzaParziale" class="giacenza-dropdown">
          <div class="dropdown-header" @click="toggleDropdown">
            Giacenze Magazzini
            <span :class="['dropdown-icon', { open: dropdownOpen }]">▼</span>
          </div>
          <ul v-show="dropdownOpen" class="dropdown-list">
            <li
              v-for="(giacenza, key) in giacenzaParziale"
              :key="key"
              class="dropdown-item"
            >
              {{ key }}: {{ giacenza.giacenza }}
            </li>
          </ul>
        </div>

        <van-button v-for="(b, index) in config.bottoni" :key="index" @click="onClickBtn(b)"
            type="default" class="btnRicercaElemento">{{ b.testo }}</van-button>
      </div>

      <!-- <input class="modalFormInput" :placeholder="item.placeHolder || 'Inserire testo..'"  v-model="value"
        :v-upper="item.forceUpper ? true : false" @change="onChange" ref="input" @focus="onFocus" @blur="onBlur" :readonly="item.readonly"  /> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  props: {
    item: Object,
    config: Object
  },
  data() {
    return {
      dropdownOpen: false // Stato del dropdown (aperto/chiuso)
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    // Controlla se esiste item.magazzino.giacenzaParziale
    hasGiacenzaParziale() {
      return (
        this.item &&
        this.item.magazzino &&
        this.item.magazzino.giacenzaParziale &&
        Object.keys(this.item.magazzino.giacenzaParziale).length > 0
      );
    },
    // Restituisce l'oggetto giacenzaParziale
    giacenzaParziale() {
      return this.hasGiacenzaParziale
        ? this.item.magazzino.giacenzaParziale
        : {};
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen; // Toggle apertura dropdown
    },
    onClickBtn(btn) {
      var method = btn.onClick
      method && method(this.item)
    },
    onClickCell() {
      const btn = this.config.bottoni.find(x => x.testo === 'Seleziona')
      if (btn) {
        this.onClickBtn(btn)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .van-cell__title{
    font-size: 2vh;
    display: flex;
    align-items: center;
    font-weight: bold;
  }

  .van-cell--large {
    border-bottom: 1px solid #ececec;
  }
  .giacenza-dropdown {
    border-radius: 4px;
    background: #f9f9f9;
    position: relative;
  
    .dropdown-header {
      padding: 10px;
      background: #e6e6e6;
      font-weight: bold;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
  
      .dropdown-icon {
        transition: transform 0.5s ease;
      }
      .dropdown-icon.open {
        transform: rotate(180deg);
      }
    }
  
    .dropdown-list {
      list-style: none;
      position: absolute;
      top: 100%;
      z-index: 100;
      background-color: #ffffff;
      width: 100%;
  
      .dropdown-item {
        padding: 8px 12px;
        border-top: 1px solid #ddd;
        border: 1px solid #ddd;
      }
  
      .dropdown-item:nth-child(even) {
        background: #ddd;
      }
    }
  }
</style>

<style lang="scss">

  .ricercaElementoField .btnRicercaElemento {
    font-size: 2vh;
    height: 5vh;
    margin-left: 5px;
    background: #ececec;
  }

</style>
